import React, {Component} from "react";
import "./Loader.css";

export default class Loader extends Component
{
	render()
	{
		if(this.props.enabler)
		{
			return (
				<div class={"container " + this.props.className}>
					<div class="dot dot-1"></div>
					<div class="dot dot-2"></div>
					<div class="dot dot-3"></div>
				</div>
			);
		}
		else
		{
			return this.props.children;
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js